<template>
  <List class="notf-pane" :split="false" :data-source="unreadNotifications" :locale="emptyLocale" row-key="index">
    <ListItem slot="renderItem" slot-scope="item" @click="$emit('show-more', item.notifyType)">
      <FriendMeta v-if="item.notifyType === notifyType.IM_MSG_RELAY_NTY" :meta="item" />
      <CoopeMetaBl v-if="item.notifyType === notifyType.COC_NTY" :meta="item" />
      <SysNoticeMeta v-if="item.notifyType === notifyType.SYSTEM_NOTICE" :meta="item" />
    </ListItem>
    <div slot="footer" class="text-blue link-more" @click="$emit('show-more')">
      {{$t('notify.ViewNotifications')}}&nbsp;&gt;
    </div>
  </List>
</template>
<script>
import { mapState } from 'vuex'
import { Empty, List } from 'ant-design-vue'
import { NOTIFY_TYPE } from '@/utils/constant'
import emptyTask from '@/assets/empty-notify.svg'
import {
  FriendMeta,
  CoopeMetaBl,
  SysNoticeMeta
} from '@/components/business/media-meta/index.js'

// 未读消息面板
export default {
  name: 'NotificationPane',
  components: {
    List,
    ListItem: List.Item,
    FriendMeta,
    CoopeMetaBl,
    SysNoticeMeta
  },
  data() {
    const h = this.$createElement
    return {
      emptyLocale: {
        emptyText: h(Empty, {
          class: 'notify-empty',
          props: {
            image: emptyTask,
            description: this.$t('home.NoNotice')
          }
        })
      }
    }
  },
  computed: {
    ...mapState('notification', ['unreadNotifications']),
    notifyType() {
      return NOTIFY_TYPE
    }
  }
}
// 未读消息实现思路：
// 每次点开此面板后，记录 userId : lastId 到存储,
// 关闭后将列表中的消息的阅读状态改为已读
// 表：消息表， 用户-消息表(用户id,消息id降序,阅读状态)
</script>
<style lang="less" scoped>
.notf-pane {
  ::v-deep .ant-list-items {
    padding-top: 8px;
    padding-bottom: 8px;
    max-height: 498px;
    overflow: auto;
    &::after {
      content: " ";
      display: block;
    }
  }

  ::v-deep .ant-list-item {
    margin: 0 8px 8px;
    padding: 20px 24px;

    &:last-child {
      border-bottom: none !important;
      margin-bottom: 0;
    }

    &:hover {
      border-radius: 8px;
      background: #f3f6fb;
      cursor: pointer;
    }
  }

  ::v-deep .ant-list-footer {
    padding: 0;
    border-top: 1px solid #edeff2;
  }

  .link-more {
    text-align: right;
    padding: 8px 32px 8px 0;
    cursor: pointer;
  }

  ::v-deep .notify-empty {
    img {
      width: 162px;
      height: 114px;
    }
  }
}
</style>
